'use strict';

var SegmentPlugin = require('@analytics/segment');
var index = require('./Pixels/TwitterPixelPlugin/index.js');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var SegmentPlugin__default = /*#__PURE__*/_interopDefault(SegmentPlugin);

var PLUGIN_REQUIRED_ARGS = {
  segment: ['writeKey'],
  twitter: []
};
var PLUGINS = {
  segment: SegmentPlugin__default["default"],
  twitter: index
};
var resolveProviderPlugins = function resolveProviderPlugins(plugins, pico_plugin_options) {
  if (plugins === void 0) {
    plugins = {};
  }
  var pluginsToUse = [];
  Object.keys(plugins).filter(function (pluginName) {
    return pluginName in PLUGIN_REQUIRED_ARGS;
  }).forEach(function (plugin) {
    var pluginConfig = plugins[plugin];

    // Make sure all required arguments are passed at instantiation
    if (PLUGIN_REQUIRED_ARGS[plugin].every(function (reqArg) {
      return !!pluginConfig[reqArg];
    })) {
      pluginsToUse.push(PLUGINS[plugin](Object.assign({}, pluginConfig, pico_plugin_options)));
    }
  });
  return pluginsToUse;
};
var resolveProviderPlugins$1 = resolveProviderPlugins;

module.exports = resolveProviderPlugins$1;
//# sourceMappingURL=resolveProviderPlugins.js.map
